import { useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import { DOCUMENTS_QUERY } from "./useDocuments";

const DELETE_DOCUMENT_MUTATION = gql`
  mutation DeleteDocument($id: ID!) {
    deleteDocument(id: $id) {
      success
    }
  }
`;

export function useDeleteDocument(projectId: string) {
  const [deleteMutation, { loading, error }] = useMutation(
    DELETE_DOCUMENT_MUTATION,
    {
      refetchQueries: [{ query: DOCUMENTS_QUERY, variables: { projectId } }],
    }
  );

  const deleteDocument = async (id: string) => {
    const { data } = await deleteMutation({ variables: { id } });
    return (data as { deleteDocument: { success: boolean } }).deleteDocument
      .success;
  };

  return { deleteDocument, loading, error };
}
